/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Channel } from '../models/Channel';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChannelsService {
    /**
     * Add a channel
     * @param workspaceId Workspace ID required
     * @param requestBody
     * @returns Channel Successfully added a channel
     * @throws ApiError
     */
    public static postChannel(
        workspaceId: string,
        requestBody: {
            name: string;
            icon: string;
        },
    ): CancelablePromise<Channel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/channel',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Deletes a channel
     * @param id The id of channel to get or delete
     * @param workspaceId Workspace ID is required in every request
     * @returns any Successfully deleted channel
     * @throws ApiError
     */
    public static deleteChannel(
        id: string,
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/channel/{id}',
            path: {
                'id': id,
            },
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                404: `Channel not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List of channels
     * @param workspaceId The workspace_id of source to get or delete
     * @param limit Limit of objects to get
     * @param offset skip number of objects to get in list
     * @returns Channel Successfully retrieved channel
     * @throws ApiError
     */
    public static getChannelList(
        workspaceId: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<Channel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/channel/list',
            query: {
                'workspace_id': workspaceId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                404: `Channels not found`,
                500: `Internal server error`,
            },
        });
    }
}
